export default __webpack_public_path__ + "static/char-s-18-cht-5b9dfcd4d4bf02490cebdc44acb85a92.webp";